// extracted by mini-css-extract-plugin
export default {"button":"Button_button__26Oph","primary":"Button_primary__aVPa1","secondary":"Button_secondary__BsVua","outline":"Button_outline__KTMCw","ghost":"Button_ghost__zJZ09"};